import { Card, CardBody, CardTitle } from "reactstrap";
import { IPosition } from "../../types/position";
import Tabs, { Tab } from "../common/tabs/tabs";
import PositionContactInfo from "../position/contact-info/contact-info";
import RoleDetails from "./Role-details/role-details";
import { useLazyQuery } from "@apollo/client";
import { GET_ORG_DETAILS } from "../../graphql/org-gql";
import { IOrg, IOrgResponse } from "../../types/org";
import { useEffect, useState } from "react";
import { CategoryType } from "../../types/constants";
import RoleDetailsGrp from "./Role-details/role-details-grp";


type RoleProps = {
  role: IPosition;
  updateSelectedRole?: (updatedRole: IPosition) => void
}


const Role = (props: RoleProps) => {
  const { role, updateSelectedRole } = props;
  const [fullPositionName,setFullPositionname]= useState<string>(role?.fullPositionName)
  const [getOrgDetail] = useLazyQuery<IOrgResponse>(GET_ORG_DETAILS)
  const [org, setOrg] = useState<IOrg>();
  useEffect(() => {
    if (role.orgId) {
      getOrgDetail({ variables: { id: role.orgId} }).then((response) => {
        response?.data?.org && setOrg(response.data.org)
      })
    }
    setFullPositionname(role?.fullPositionName)
  }, [role])

  const tabs: Tab[] = [
    {
      title: 'Role Details',
      content: <>
               {org?.details?.category?.type === CategoryType.ORGANIZATION && <RoleDetails role={role} updateSelectedRole={updateSelectedRole} ></RoleDetails>}
               {org?.details?.category?.type !== CategoryType.ORGANIZATION && <RoleDetailsGrp role={role} updateSelectedRole={updateSelectedRole} ></RoleDetailsGrp>}
      </>
      
    },
    {
      title: 'Contact Information',
      content: <PositionContactInfo position={role}></PositionContactInfo>
    }
  ]

  return (
    <Card aria-label="Role Information">
      <CardBody>
        <CardTitle>
          Role: {fullPositionName}
        </CardTitle>

        <Tabs tabs={tabs} />
      </CardBody>
    </Card>
  )

}

export default Role;
